import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "./i18n";

import App from "./App";
import { Loader } from "./component/Loader/Loader";

import { GlobalStyle } from "./GlobalStyle";
import { theme } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<ThemeProvider theme={theme}>
			<GlobalStyle />
			<Suspense fallback={<Loader margin="margin" />}>
				<App />
			</Suspense>
		</ThemeProvider>
	</BrowserRouter>
);
